import React, {Component} from "react"
import styles from "./SubMenu.module.css"
import classNames from "classnames"
import {ReactComponent as MinusIcon} from "../img/minus-circle.svg"
import {FormID, Screen} from "interfaces"
import {observable} from "mobx"

interface Props {
    items: {value: FormID; label: string}[]
    onClick: (id: FormID) => void
    selected: FormID
    checkedItems: FormID[]
    enabledItems: FormID[]
    screen: Screen
    isDrawer?: boolean
}

export class SubMenu extends Component<Props, {}> {
    @observable
    private wrapperRef: any

    constructor(props) {
        super(props)
        this.wrapperRef = React.createRef()
        this.handleClickOutside = this.handleClickOutside.bind(this)
    }

    componentDidMount() {
        if (!this.props.isDrawer && this.props.screen !== "desktop") {
            document.addEventListener("mousedown", this.handleClickOutside)
        }
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside)
    }

    handleClickOutside(event) {
        // Only handle outside clicks for tablet floating popup mode, never in drawer or desktop
        if (this.props.isDrawer || this.props.screen === "desktop") {
            return
        }
        if (
            this.wrapperRef &&
            this.wrapperRef.current &&
            !this.wrapperRef.current.contains(event.target)
        ) {
            // Do not invoke onClick(undefined) which triggers drawer close and corrupts state
        }
    }

    public render() {
        const {items, onClick, selected, checkedItems, enabledItems, screen, isDrawer} = this.props
        const isDesktopMode = screen === "desktop" || isDrawer

        return (
            <ul
                className={classNames(styles.root, this.props.isDrawer && styles.drawerRoot)}
                ref={this.wrapperRef}>
                {items.map((item) => {
                    const form_id: FormID = item.value
                    if (!enabledItems.includes(form_id)) {
                        return null
                    }

                    let clazz = styles.button
                    if (item.value === selected) {
                        clazz = `${styles.button} ${styles.selected}`
                    }
                    const checked = checkedItems.includes(item.value)

                    return (
                        <li key={item.value} className={styles.item}>
                            <button
                                className={clazz}
                                onClick={() => {
                                    onClick(item.value)
                                }}>
                                <span className={styles.label}>{item.label}</span>
                                <Icon
                                    checked={checked}
                                    screen={screen}
                                    isDesktopMode={isDesktopMode}
                                />
                            </button>
                        </li>
                    )
                })}
            </ul>
        )
    }
}

interface IconProps {
    checked: boolean
    screen: Screen
    isDesktopMode?: boolean
}

function Icon({checked, screen, isDesktopMode}: IconProps) {
    if (checked) {
        return (
            <svg
                className={styles.checkSvg}
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2.5 6.2L5 8.7L9.5 3.3"
                    stroke="#059669"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )
    }

    if (!checked && isDesktopMode) {
        return <div className={styles.uncheckedCircle} />
    }

    const props = {width: "11", height: "11"}
    return <MinusIcon {...props} className={styles.iconMinus} />
}
